module.exports = {
    gameNetworkId:238
};


//////////////////
// WEBPACK FOOTER
// ./cfg/game-config.js
// module id = 20
// module chunks = 0